import {Component,ViewChild} from '@angular/core';
import {ScalingComponent} from '../scaling/scaling.component';
import * as activityDataObj from '../../shared/content/activityData.json';
import { interActivityServices } from '../../shared/services/interactivity.services';



@Component({
  selector: 'app-root',
  templateUrl: './wrapper.component.html',
  styleUrls: ['./wrapper.component.css']
})
export class WrappperComponent {
  @ViewChild('container') container;
  public commonData = (<any>activityDataObj).commonData;

  constructor(public scalingComponent: ScalingComponent, public activityServices: interActivityServices){}
     ngOnInit() {
      this.scalingComponent.doScaling(this.container)
     }
     onResize(event) {
      this.scalingComponent.doScaling(this.container)
    }
  
}


